import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

// Hardwood floor background style - ADJUSTABLE
const hardwoodFloorStyle = {
  background: `
    repeating-linear-gradient(
      90deg,
      #3d2817 0px,
      #4a3423 2px,
      #5c4033 4px,
      #4a3423 6px,
      #3d2817 8px
    ),
    repeating-linear-gradient(
      0deg,
      transparent 0px,
      transparent 60px,
      rgba(0,0,0,0.15) 60px,
      rgba(0,0,0,0.15) 62px
    ),
    linear-gradient(180deg, #4a3423 0%, #3d2817 50%, #2d1f12 100%)
  `,
  backgroundBlendMode: "overlay, overlay, normal"
};

// Page watermark component - ADJUSTABLE props: size, opacity, top, left
function PageWatermark({ size = 700, opacity = 0.1, top = "50%", left = "50%" }) {
  return (
    <img
      src="/BuckEuchreLogo.png"
      alt=""
      style={{
        position: "fixed",
        top,
        left,
        transform: "translate(-50%, -50%)",
        width: size,
        height: "auto",
        opacity,
        pointerEvents: "none",
        zIndex: 0
      }}
    />
  );
}

export default function AboutPage() {
  return (
    <>
    <SEO
      title="About Euchre Table"
      description="Euchre Table is the home of online Buck Euchre. Learn about our mission to bring the classic card game to players everywhere."
      path="/about"
    />
    <div style={{ ...hardwoodFloorStyle, minHeight: '100vh', position: 'relative' }}>
      <PageWatermark size={500} opacity={0.08} />
      <div style={{ padding: '60px 32px', maxWidth: 800, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h1 style={{ fontSize: 36, fontWeight: 700, marginBottom: 24 }}>
          About Buck Euchre
        </h1>

        <div style={{
          background: '#161b22',
          borderRadius: 12,
          padding: 32,
          border: '1px solid #30363d',
          marginBottom: 24
        }}>
          <h2 style={{ fontSize: 24, marginBottom: 16, color: '#58a6ff' }}>Our Story</h2>
          <p style={{ color: '#c9d1d9', lineHeight: 1.8 }}>
            Buck Euchre is a beloved card game that has been played in homes and gatherings
            for generations. This digital version brings the classic game to your screen,
            complete with AI opponents that learn and adapt to your playing style.
          </p>

          <h2 style={{ fontSize: 24, marginBottom: 16, marginTop: 32, color: '#58a6ff' }}>Features</h2>
          <ul style={{ color: '#c9d1d9', lineHeight: 1.8, paddingLeft: 24 }}>
            <li>Play against intelligent AI opponents</li>
            <li>Track your game history and statistics</li>
            <li>Play money mode for casual games</li>
            <li>Real money mode for competitive play (coming soon)</li>
            <li>AI that learns from every game played</li>
          </ul>

          <h2 style={{ fontSize: 24, marginBottom: 16, marginTop: 32, color: '#58a6ff' }}>Contact</h2>
          <p style={{ color: '#8b949e', lineHeight: 1.6 }}>
            Have questions or feedback? We'd love to hear from you!
          </p>
        </div>

        <Link
          to="/"
          style={{
            display: 'inline-block',
            color: '#58a6ff',
            textDecoration: 'none',
            fontSize: 15
          }}
        >
          &larr; Back to Home
        </Link>

        <nav style={{
          borderTop: '1px solid #30363d',
          marginTop: 32,
          paddingTop: 20,
        }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: '#8b949e', marginBottom: 12 }}>Related Pages</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 24px' }}>
            <Link to="/buck-euchre-rules" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Buck Euchre Rules</Link>
            <Link to="/buck-euchre-strategy" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Strategy Guide</Link>
            <Link to="/tutorial" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Tutorial</Link>
            <Link to="/leaderboards" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Leaderboards</Link>
            <Link to="/fairness" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Fairness</Link>
            <Link to="/euchre-variations" style={{ color: '#58a6ff', textDecoration: 'none', fontSize: 15 }}>Euchre Variations</Link>
          </div>
        </nav>
      </div>
    </div>
    </>
  );
}
